if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // Run native HTML5 validation for everything in the form
  if (!this.form.checkValidity()) {
    this.form.reportValidity();             // shows the native tooltip
    this.submitButton.removeAttribute('aria-disabled');
    this.submitButton.disabled = false;
    return;                                 // stop here if invalid
  }

        if (document.body.classList.contains('template-product-monogram')) {
        // --- Monogram field validation ---
const monogramInput = this.form.querySelector('[name="properties[Monogram]"]');
if (monogramInput && monogramInput.offsetParent !== null) {
  const value = monogramInput.value.trim();
  if (value.length === 0) {
    monogramInput.focus();
    monogramInput.reportValidity(); // triggers browser validation tooltip
    this.submitButton.removeAttribute('aria-disabled');
    this.submitButton.disabled = false;
    return; // stop the add-to-cart process
  }
}
        }
// --- End monogram validation ---


        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');

            // ✅ Always re-enable the ATC button
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.disabled = false;

            // ✅ Re-enable dynamic payment button (Shop Pay, etc.)
            const shopPayButton = this.querySelector('[data-shopify-buttoncontainer] [type="submit"]');
            if (shopPayButton) {
              shopPayButton.disabled = false;
              shopPayButton.removeAttribute('aria-disabled');
              shopPayButton.classList.remove('disabled'); // some themes add this
            }

            // // ✅ Remove visually disabled state from Shopify payment container (optional)
            // const buttonWrapper = this.querySelector('[data-shopify-buttoncontainer]');
            // if (buttonWrapper) {
            //   buttonWrapper.classList.remove('shopify-payment-button--disabled');
            // }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
